import script from "./admin-sidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./admin-sidebar.vue?vue&type=script&setup=true&lang=js"

import "./admin-sidebar.vue?vue&type=style&index=0&id=6575257a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6575257a"]])

export default __exports__